class Search {
    constructor(data) {
        this.take = 10;
        this.data = data;
    }

    get() {
        this.buildFilters();
        return this.filters;
    }

    buildFilters() {
        this.filters = {
            'user_id': typeof this.data.user_id !== 'undefined' ? this.data.user_id : App.user.id,
            'licensed_in': [],
            'name': this.getName(),
            'reviewed': false,
            'not_reviewed': false,
            'order_recent_by_publish_date': true,
            'favorites_first': true,
            'add_separator': 'song_published_at',
            'randomize_by_day': false,
            'only_of_user': false,
            'gradually': true,
            'published': true,
            'uploader_id': null,
            'only_received_as_suggestion': false,
            'take': this.take,
            'skip': this.getSkip(),
        };

        if(this.data.playlists){
            this.filters.playlists = this.data.playlists;
        }

        if(this.data.uploader_id){
            this.filters.uploader_id = this.data.uploader_id;
        }

        if(this.data.country_id){
            this.filters.country_id = this.data.country_id;
        }        

        if (this.hasGenres()) {
            this.filters.genres = this.data.genres;
        }

        if (this.getAvailableIn().length){
            this.filters.available_in = this.getAvailableIn();
        }

        if (this.getLicensedIn().length){
            this.filters.licensed_in = this.getLicensedIn();
        }

        if (typeof this.data.published !== 'undefined'){
            this.filters.published = this.data.published;
        }
    }

    getAvailableIn() {
        var countries = [];

        if (this.data.available && this.data.available.length > 0) {
            // Concat with countries provided in search form
            return countries.concat(this.data.available);
        }

        return countries;
    }

    getLicensedIn() {
        var countries = [];

        if (this.data.licensed && this.data.licensed.length > 0) {
            // Concat with countries provided in search form
            return countries.concat(this.data.licensed);
        }
        return countries;
    }

    hasGenres() {
        return this.data.genres && this.data.genres.length > 0;
    }

    getName() {
        return this.data.name;
    }

    getSkip() {
        return (this.data.page - 1) * this.take;
    }
 
}

export default Search;